<template>
  <DescriptionList>
    <DescriptionListEntry v-for="entry in entries" :key="entry.key">
      <template #key>
        <DescriptionListKey> {{ entry.key }}: </DescriptionListKey>
      </template>

      <template #values>
        <DescriptionListValue
          v-for="value in wrapToArray(entry.value)"
          :key="value"
        >
          {{ fallback(value) }}
        </DescriptionListValue>
      </template>
    </DescriptionListEntry>
  </DescriptionList>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import { wrapToArray, fallback } from "@/helpers";
import DescriptionList from "../DescriptionList/DescriptionList.component.vue";
import DescriptionListEntry from "../DescriptionList/DescriptionListEntry.component.vue";
import DescriptionListKey from "../DescriptionList/DescriptionListKey.component.vue";
import DescriptionListValue from "../DescriptionList/DescriptionListValue.component.vue";
import type { InfoListEntry } from "./InfoListEntry.model";

defineProps({
  entries: {
    type: Array as PropType<Array<InfoListEntry>>,
    default: () => [],
  },
});
</script>
